// extracted by mini-css-extract-plugin
export default {"infoBlockItem":"infoBlock_infoBlockItem__VNs+v"};